module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-BoldItalic-2631d514f038de32bbb18e7c7a6395ee.ttf";